import React, { useEffect, useState, useContext } from 'react'
import { apiGet, apiPost } from '../../utils/apiFetch'
import Pagination from '../Pagination'
import ODateRangePicker from 'components/shared/datePicker/ODateRangePicker'
import { useTranslation } from 'react-i18next'
import pathObj from '../../utils/pathObj'
import DeviceIdentification from './DeviceIdentification'
import WithDrawMoneyBank from './withdrawMoneyToBank'
import Transactions from './Transactions'
import TransactionLimit from './TransactionLimit'
import { BsCloudDownloadFill } from 'react-icons/bs'
import dayjs from 'dayjs'
import helpers from '../../utils/helpers'
import AuthContext from 'context/AuthContext'
import useToastContext from 'hooks/useToastContext'

function Aml () {
  const { t } = useTranslation()
  const notification = useToastContext()
  const { updatePageName } = useContext(AuthContext)
  const [pagination_obj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })

  const [page, setPage] = useState(1)
  const [startDate, setStartDate] = useState('')
  const [endDate, setEndDate] = useState('')

  const [type, setType] = useState('')
  const [isReset, setIsReset] = useState(false)
  const [reports, setReports] = useState({})
  const [status, setStatus] = useState('')
  const [reportFormat, setReportFormat] = useState('')
  const [sort, setSort] = useState({
    sort_key: 'createdAt',
    sort_type: 'desc'
  })

  const pageSize = 10

  const getReports = async () => {
    try {
      let params = {
        page_size: pageSize,
        page,
        sort_key: sort.sort_key,
        sort_type: sort.sort_type,
        status: status
      }
      if (startDate) {
        params.startDate = startDate
          ? dayjs(startDate).format('YYYY-MM-DD')
          : null
      }
      if (endDate) {
        params.endDate = endDate ? dayjs(endDate).format('YYYY-MM-DD') : null
      }
      if (type) {
        params.type = type
      }
      if (!type) {
        return
      }

      const res = await apiGet(pathObj.aml, params)
      const resultStatus = res?.data?.success

      setReports(res?.data?.results)
      setPaginationObj({
        ...pagination_obj,
        page: resultStatus ? res?.data?.results?.page : null,
        pageCount: resultStatus ? res?.data?.results?.totalPages : null,
        perPageItem: resultStatus ? res?.data?.results?.docs?.length : null,
        totalItems: resultStatus ? res?.data?.results?.totalDocs : null
      })
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    getReports()
  }, [startDate, endDate, type, page, status, sort])

  const handleReset = () => {
    setStartDate('')
    setEndDate('')
    setIsReset(true)
    setType('')
    setPaginationObj({})
    setStatus('')
    setReportFormat('')
  }
  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  const handleDateChange = (start, end) => {
    setStartDate(start)
    setEndDate(end)
    setPage(1)
    setIsReset(false)
  }

  const handleReportType = e => {
    setReports([])
    setPaginationObj({})
    setType(e.target.value)
    setPage(1)
    setIsReset(false)
  }

  const handleDownloadReport = async () => {
    try {
      let sendData = {}
      if (startDate) {
        sendData.startDate = startDate
          ? dayjs(startDate).format('YYYY-MM-DD')
          : null
      }
      if (endDate) {
        sendData.endDate = endDate ? dayjs(endDate).format('YYYY-MM-DD') : null
      }
      if (type) {
        sendData.type = type
      }
      if (status) {
        sendData.status = status
      }
      const res = await apiPost(pathObj.downloadAml, sendData)
      if (res.data.success) {
        helpers.downloadFile(res?.data?.results?.file_path)
      } else {
        console.log('res', res)
        notification.error(res?.data?.message)
      }
    } catch (error) {
      console.log('error:', error)
    }
  }

  useEffect(() => {
    updatePageName(t('NAV_AML'))
  }, [])

  return (
    <div>
      <div className='bg-[#F9F9F9]'>
        <div className='px-3 py-4'>
          <div className='bg-white border border-[#E9EDF9] rounded-lg'>
            {/* filter section */}
            <form className='border-b border-b-[#E3E3E3]  px-4 py-3 pt-5 flex flex-wrap justify-between'>
              <div className='col-span-2 flex flex-wrap  items-center'>
                <div className='flex items-center lg:pt-0 pt-3 flex-wrap '>
                  <ODateRangePicker
                    handleDateChange={handleDateChange}
                    isReset={isReset}
                    setIsReset={setIsReset}
                  />
                  <div style={{ height: '50px' }}>
                    <button
                      type='button'
                      onClick={handleReset}
                      className='bg-LightBlue text-sm px-8 ml-3 py-2 rounded-lg items-center border border-transparent text-white hover:bg-DarkBlue sm:w-auto w-1/2'
                    >
                      {t('O_RESET')}
                    </button>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center px-4'>
                <label
                  htmlFor='default-search'
                  className='mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white'
                >
                  {t('O_SEARCH')}
                </label>
                <div className='flex'>
                  <div className='relative mr-4'>
                    <div>
                      <select
                        name='cars'
                        id='cars'
                        style={{
                          border: 'solid 1px #d9d9d9',
                          padding: '5px 10px',
                          height: '40px',
                          outline: 'none',
                          borderRadius: '8px'
                        }}
                        value={type}
                        onChange={handleReportType}
                      >
                        <option value=''>{t('SELECT_AML_REPORT')}</option>
                        <option value='deviceIdentification'>
                          {t('DEVICE_IDENTIFICATION')}
                        </option>
                        <option value='withdrawMoneyToBank'>
                          {t('O_WITHDRAW_BANK_AML')}
                        </option>
                        <option value='transactionInDay'>
                          {t('O_TRANSACTION_IN_DAY')}
                        </option>
                        <option value='transactionLimit'>
                          {t('O_TRANSACTION_LIMIT')}
                        </option>
                      </select>
                    </div>
                  </div>

                  {[
                    'deviceIdentification',
                    'withdrawMoneyToBank',
                    'transactionInDay',
                    'transactionLimit'
                  ].includes(type) && (
                    <div
                      className='flex items-center cursor-pointer'
                      onClick={handleDownloadReport}
                    >
                      <BsCloudDownloadFill
                        style={{
                          width: '1.5rem',
                          height: '1.5rem',
                          marginLeft: '1rem'
                        }}
                        title='Download report'
                      />
                    </div>
                  )}
                </div>
              </div>
            </form>
            <section className='table-section'>
              {type === '' ? (
                <div
                  className='text-center '
                  style={{
                    fontSize: '20px',
                    fontWeight: '500',
                    marginTop: '2rem',
                    marginBottom: '1rem'
                  }}
                >
                  {t('SELECT_AML_REPORT_TYPE')}
                </div>
              ) : type === 'deviceIdentification' ? (
                <DeviceIdentification
                  reports={reports}
                  setSort={setSort}
                  sort={sort}
                  page={page}
                />
              ) : type === 'withdrawMoneyToBank' ? (
                <WithDrawMoneyBank
                  reports={reports}
                  setSort={setSort}
                  sort={sort}
                  page={page}
                />
              ) : type === 'transactionInDay' ? (
                <Transactions
                  reports={reports}
                  setSort={setSort}
                  sort={sort}
                  page={page}
                />
              ) : type === 'transactionLimit' ? (
                <TransactionLimit
                  reports={reports}
                  setSort={setSort}
                  sort={sort}
                  page={page}
                />
              ) : null}

              {pagination_obj?.totalItems ? (
                <Pagination
                  handlePageClick={handlePageClick}
                  options={pagination_obj}
                  page={page}
                />
              ) : null}
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Aml
